// extracted by mini-css-extract-plugin
export default {"user_icon":"App_user_icon__YLBS5","uppercase":"App_uppercase__VVEPD","button":"App_button__httav","red":"App_red__PlXRB","submenu":"App_submenu__XiPZE"};